import { BackendError, PagarmeError } from './base';
import General from './general';

class AlreadyHasActivePaidSubscription extends BackendError {}
class CouldNotUncancelSubscription extends General.NotFound {}
class CouldNotUpdateSubscription extends General.NotFound {}
class ErrorCreatingPagarmeSubscription extends PagarmeError {}
class PlanDoesNotAcceptPaymentMethod extends BackendError {}
class PlanDoesNotExist extends General.NotFound {}
class SubscriptionDoesNotExist extends General.NotFound {}

export default {
    AlreadyHasActivePaidSubscription,
    CouldNotUncancelSubscription,
    CouldNotUpdateSubscription,
    ErrorCreatingPagarmeSubscription,
    PlanDoesNotAcceptPaymentMethod,
    PlanDoesNotExist,
    SubscriptionDoesNotExist,
};
